import { Bot, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { useAppSelector } from '@/hooks/useAppSelector';
import { openDrawer, selectCopilotState } from '@/store/slices/copilot/copilotSlice';
import { selectConversationMetrics, loadMockConversations } from '@/store/slices/copilot/copilotChatSlice';
import { Badge } from '@/components/ui/badge';
import { useEffect } from 'react';
import { useCopilotAuth } from '@/hooks/copilot/useCopilotAuth';

export const CopilotSidebarButton = () => {
  const dispatch = useAppDispatch();
  const { isOpen } = useAppSelector(selectCopilotState);
  const metrics = useAppSelector(selectConversationMetrics);
  const { userTeams } = useCopilotAuth();
  
  // Load conversations when the component mounts
  useEffect(() => {
    console.log('CopilotSidebarButton: Loading conversations');
    // dispatch(loadMockConversations());
  }, [dispatch]);
  
  const handleOpenCopilot = () => {
    console.log('Opening Copilot drawer', { isCurrentlyOpen: isOpen });
    // Force the drawer to open, regardless of current state
    dispatch(openDrawer());
  };

  // Show badge if there are conversations
  const showBadge = metrics.totalConversations > 0;

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <div className="relative">
          <Button
            variant="ghost"
            size="icon"
            className="w-10 h-10 rounded-lg hover:bg-muted/80 flex justify-center items-center 
              transition-all duration-200 active:scale-95"
            onClick={handleOpenCopilot}
            aria-label="Open Pullse Copilot"
          >
            <Bot className="h-5 w-5" />
          </Button>
          
          {showBadge && (
            <Badge 
              variant="default"
              className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-[10px]"
            >
              {metrics.totalConversations > 99 ? '99+' : metrics.totalConversations}
            </Badge>
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent side="right">
        <div className="text-center">
          <p>Open Copilot</p>
          <p className="text-xs text-muted-foreground mt-1">
            Teams: {userTeams.map(team => team.name).join(', ')}
          </p>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};
